import React from 'react';
import { useSelector } from 'react-redux';
import { useExperience } from '@unisporkal/experiences';
import Grid from './Grid/Grid';
import Carousel from './Carousel/Carousel';

const CreativeImageHome = () => {
  const hideCarousel = useSelector(
    (state) => state.creativeImageHomeData.hideCarousel
  );
  const isCarouselOfferActive = useExperience(
    'ReactCreativeCarousel'
  ).isOfferActive('Carousel');

  return (
    <>
      {!hideCarousel && isCarouselOfferActive && <Carousel />}
      <Grid />
    </>
  );
};

export default CreativeImageHome;
